import { Typography } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";

/**
 * @author IKlapouch
 * 19/07/2021
 */

const style = {
  versionLabel: {
    fontSize: "12px",
  },
};

const Version = () => {
  const { t } = useTranslation();
  const initialState = { versionNumber: '' };

  const [newVersion, setNewVersion] = React.useState(null);

  React.useEffect(() => {

    setNewVersion(sessionStorage.getItem("versionNumber"))
    //Service.get(sample)
    //  .then(response => setNewVersion(response.data[0].versionNumber))
    //  .catch((e) => { })
  }, []);

  return (
    <Typography style={style.versionLabel}>
      {`${t("version")} ${newVersion}`}
    </Typography>
  );
}

export default React.memo(Version);